import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { Button } from "@/core/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";

export const ReloadSidebarButton = ({
  onClick,
  entityName,
}: {
  onClick: () => void;
  entityName: string;
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button
        variant="tertiary"
        size="sm"
        className="gap-2 px-3"
        type="button"
        onClick={onClick}
      >
        <ArrowPathIcon />
        {entityName}
      </Button>
    </TooltipTrigger>
    <TooltipContent>
      The {entityName} was not displayed because it was still being processed.
      Click here to reload.
    </TooltipContent>
  </Tooltip>
);
